<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-5">
            
            <div class="text-center p-2">
                <h3>{{ $t('auth.changePassword.title') }}</h3>
            </div>
        
            <div class="text-center p-2">
                {{ $t('auth.changePassword.text') }}
            </div>
        
        </div>

        <div class="text-center">
            <div class="pb-4 ">
                <button id="top" @click="top" class="btn btn-primary">{{
                    $t('auth.changePassword.buttom') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'edit-user-profile-module',
        methods: {
            top: function(event){
                this.$router.push('/login');
            }
        }
    }
</script>

<style scoped>
    .btn-primary {
        width: 85px;
    }
</style>
